import { defineComponent as _defineComponent } from 'vue'
import { ExclamationCircleIcon, InformationCircleIcon, XIcon } from '@heroicons/vue/solid';

type ValidationType =
    | 'OUT_OF_SCOPE'
    | 'INVALID_INTENT'
    | 'AGENT_NAME_AMBIGUOUS'
    | 'INPUT_TOO_SHORT'
    | 'NO_SEMANTIC_CONTENT';

interface Props {
    errorType: ValidationType;
    message: string;
    suggestion?: string;
    dismissible?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraValidationMessage',
  props: {
    errorType: { type: String, required: true },
    message: { type: String, required: true },
    suggestion: { type: String, required: false, default: '' },
    dismissible: { type: Boolean, required: false, default: false }
  },
  emits: ["dismiss"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const isWarning = (type: ValidationType) => type !== 'NO_SEMANTIC_CONTENT';

const labelByType: Record<ValidationType, string> = {
    OUT_OF_SCOPE: 'Fora de Escopo',
    INVALID_INTENT: 'Entrada Inválida',
    AGENT_NAME_AMBIGUOUS: 'Filtro Ambíguo',
    INPUT_TOO_SHORT: 'Entrada Curta',
    NO_SEMANTIC_CONTENT: 'Não Compreendido',
};

const iconByType: Record<ValidationType, typeof ExclamationCircleIcon> = {
    OUT_OF_SCOPE: ExclamationCircleIcon,
    INVALID_INTENT: InformationCircleIcon,
    AGENT_NAME_AMBIGUOUS: InformationCircleIcon,
    INPUT_TOO_SHORT: InformationCircleIcon,
    NO_SEMANTIC_CONTENT: ExclamationCircleIcon,
};

const dismiss = () => emit('dismiss');

const __returned__ = { props, emit, isWarning, labelByType, iconByType, dismiss, get XIcon() { return XIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})